import { render, staticRenderFns } from "./ujipetik.vue?vue&type=template&id=1b59aeb4"
import script from "./ujipetik.vue?vue&type=script&lang=js"
export * from "./ujipetik.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports